import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import SunEditor from 'suneditor-react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Hidden from '@material-ui/core/Hidden';
import Chip from '@material-ui/core/Chip';

import ActivityContext from '../../context/activity-context'
import useStyles from '../../styles/components/learningcontent/stylesLearningContentDetailsHolder'

const ActivityDetailContainer = () => {

    const classes = useStyles();
    const { activityContext, dispatch } = useContext(ActivityContext);

    const handleClickTabs = (item) => {
        switch (item) {
            case "assessment":
                activityContext.tabs.content = false;
                activityContext.tabs.assessment = true;
                dispatch({ type: 'SET_TABS', tabs: activityContext.tabs });
                break;
        }
    }

    return (
        <ActivityContext.Provider value={{ activityContext, dispatch }}>
            <Grid container direction={'column'} alignContent={'center'} justify={'center'} >
                <Grid classes={{ root: classes.customLayoutVideo }}>
                    <SunEditor
                        showToolbar={false}
                        enableToolbar={false}
                        disable={true}
                        setOptions={{
                            height: "100%",
                            resizingBar: false,
                        }}
                        toggleFullScreen={true}
                        setContents={activityContext.activity.ActivityContent}
                        showController={false}
                    />
                </Grid>
            </Grid>
            <Hidden lgUp>
                <Chip icon={<ArrowBackIcon />}
                    style={{ position: "fixed", bottom: '15px', right: '5px' }}
                    color="secondary"
                    label="Assessment"
                    clickable
                    onClick={() => handleClickTabs("assessment")}
                />
            </Hidden>
        </ActivityContext.Provider>
    )
}

export default ActivityDetailContainer;